/**
 * style 属性的最小解析/改写（不依赖 CSSOM）——
 * 外部 SVG 常用 style="fill:#f00" 覆盖同名属性；若只用 CSSStyleDeclaration，
 * 各环境（浏览器 / jsdom）行为不一致。这里自己做，行为可预期且可单测。
 */

/** style="a:1; b:2" → [['a','1'], ['b','2']] */
export function parseStyleAttr(value: string | null | undefined): Array<[string, string]> {
  if (!value) return [];
  return value
    .split(';')
    .map((s) => s.trim())
    .filter(Boolean)
    .map((decl) => {
      const i = decl.indexOf(':');
      return i < 0 ? [decl, ''] : [decl.slice(0, i).trim(), decl.slice(i + 1).trim()];
    });
}

export function styleValue(value: string | null | undefined, name: string): string | null {
  const hit = parseStyleAttr(value).find(([prop]) => prop === name);
  return hit && hit[1] !== '' ? hit[1] : null;
}

/** 生成去掉某项后的 style 文本；原本不含该项（或为空）时返回 null 表示无需改动 */
export function styleWithoutProp(value: string | null | undefined, name: string): string | null {
  const decls = parseStyleAttr(value);
  if (decls.length === 0 || !decls.some(([prop]) => prop === name)) return null;
  return decls
    .filter(([prop]) => prop !== name)
    .map(([prop, val]) => `${prop}: ${val};`)
    .join(' ');
}
